import {
  Box,
  IconButton,
  ImageListItem,
  ImageListItemBar,
  TextField,
  Tooltip,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomSelectBox from "../../components/CustomSelectBox/CustomSelectBox";
import {
  addEditStepFour,
  editStepFour,
  editStepFourTempImage,
  fetchAllProduct,
  resetEdit,
  resetImagesAfterUpload_EditMod,
  resetUploadState,
  updateProduct,
  uploadImages,
} from "../../redux/features/product.features";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import "./priceUpdate.css";
import InfoIcon from "@mui/icons-material/Delete";
import { Image, VideoCall } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import { reset } from "../../redux/features/broker.features";
import spinner from '../../assets/Spinner-1s-200px.svg'


const initialValue = {
  buyCurrency: "LKR",
  buyPrice: "0.00",
  sellPriceLocal: "0.00",
  sellLocalCurrency: "LKR",
  sellForeignersCurrency: "USD",
  sellPriceForeigners: "0.00",
};

const ProductImageAndVideoUpdate = () => {
  const dispatch = useDispatch();
  const [values, setValues] = useState(initialValue);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [searchValue, setSearchValue] = useState("");
  let productState = useSelector((state) => {
    return state.productReducer;
  });
  let { products, editProduct, updateImages } = productState;
  let { loading, errorMessage, successMessage } = editProduct;
  let { stepFour } = editProduct;

  const Input = styled("input")({
    display: "none",
  });

  const [imgList, setImageList] = useState(stepFour.imagesUrl || []); //already saved images on db
  const [imgPreview, setImgPreview] = useState([]); //saved image previews
  const [tempImageList, setTempImageList] = useState([]); //newly added images still not saved to db
  const [tempImgPreview, setTempImgPreview] = useState([]); //newly added images still not saved to db

  const [videoList, setVideoList] = useState(stepFour.videosUrl || []);
  const [videoPreview, setVideoPreview] = useState([]);
  const [uploaded, setUploaded] = useState(false);
  const [btnDisable, setbtnDisable] = useState(false);

  const addImage = (e) => {
    let tmp = [...e.target.files];
    setbtnDisable(false)

    if (tempImageList.length !== 0) {
      tmp = tmp.concat(tempImageList);
    }
    console.log("tmp", tmp);
    setTempImageList([...tmp]);
    setTimeout(() => {
      const d = {
        images: tmp,
        videos: videoList,
      };

      dispatch(editStepFourTempImage(d));
    }, 1000);
  };
  const addVideo = (e) => {
    setVideoList([...e.target.files]);
  };

  const removeItem = (list, index, setState) => {
    if (index > -1) {
      list.splice(index, 1);
      setState([...list]);
    }
  };

  useEffect(() => {
    // if (imgList.length < 1 ) return ;
    const newImgUrl = [];
    const oldImgUrl = [];
    imgList.forEach((img) => oldImgUrl.push(img));
    tempImageList.forEach((img) => newImgUrl.push(URL.createObjectURL(img)));
    setImgPreview(oldImgUrl);
    setTempImgPreview(newImgUrl);
    // if (videoList.length < 1 ) return ;
    // const newVideoUrl = [];
    // videoList.forEach((video) => newVideoUrl.push(URL.createObjectURL(video)));
    // setVideoPreview(newVideoUrl);

    return () => {};
  }, [imgList, tempImageList]);

  const removeImageItem = (list, index) => {
    if (window.confirm("Are you sure you want to delete this image or video ?")) {
    
      if (index > -1) {
        let filteredList = list.filter((x, i) => i !== index);
  
        setImageList([...filteredList]);
  
        const d = {
          imagesUrl: filteredList,
          videosUrl: videoList,
        };
  
        dispatch(editStepFour(d));
  
        const finalData = [
          {
            _id: selectedProduct.id,
            images: filteredList,
          },
        ];
        dispatch(updateProduct(finalData));
  
        alert("image delete success!");
  
  
      }
    
    }
    
  };
  const removeNotSavedImageItem = (list, index) => {
    if (window.confirm("Are you sure you want to delete this image or video ?")) {

      if (index > -1) {
        let filteredList = list.filter((x, i) => i !== index);
  
        setTempImageList([...filteredList]);
  
        const d = {
          images: filteredList,
          videos: videoList,
        };
  
        dispatch(editStepFourTempImage(d));

   

      }
    }

  
  };

  useEffect(() => {
    dispatch(fetchAllProduct());
  }, [dispatch]);

  useEffect(() => {
    const newImgUrl = [];
    const oldImgUrl = [];
    imgList.forEach((img) => oldImgUrl.push(img));
    tempImageList.forEach((img) => newImgUrl.push(URL.createObjectURL(img)));
    setImgPreview(oldImgUrl);
    setTempImgPreview(newImgUrl);

    return () => {};
  }, [imgList, tempImageList]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const searchItem = () => {

    setbtnDisable(false)

    if (
      products.filter((x) => Number(x.productId) === Number(searchValue))
        .length === 0
    )
      return alert("Item not found, please enter correct item id");

    const item = products.filter(
      (x) => Number(x.productId) === Number(searchValue)
    )[0];
    const finalValues = {
      _id: item.id,
      images: item.images,
      videos: item.videos,
    };
    if (item.images.length === 0)
      alert("This item doesn't have any images, please upload it");
    setValues(finalValues);
    setSelectedProduct(item);
    setImageList(item.images);
    // videoList(item.videos)
    dispatch(
      editStepFour({
        imagesUrl: item.images,
      })
    ); //adding to redux local storage
  };
  const uploadImageAndUpdate = () => {
    if (window.confirm("Are you sure you want to save this image or video ?")) {
      if(stepFour.images.length !==0) {
        stepFour.images.map((x,i) => {
        console.log("Uploading images : ",i+1, x)
        return dispatch(uploadImages(x));
      });
      setUploaded(true);
    setbtnDisable(true)

    }
    }else{
    setbtnDisable(false)

    }
  };

  useEffect(()=>{

    if(!selectedProduct.id) {reset(); console.log("useEffect reset calling")}

  },[])


  const reset = () => {
    dispatch(resetUploadState());
    dispatch(resetEdit());
    setValues(initialValue);
    setSelectedProduct({});
    setImageList([]);
    setTempImageList([]);
    setImgPreview([]);
    setTempImgPreview([]);
    setUploaded(false);
    setSearchValue("");
  };
  useEffect(() => {
    if (uploaded) {
      if (stepFour.imagesUrl.length === 0)
        return alert("There is no images available to upload");
      console.log("selectedProduct,", selectedProduct);
      if (!selectedProduct.id) return alert("There is no items selected");
      if(selectedProduct.images.length ===0){
        //very first time image uploading
        if (stepFour.images.length === stepFour.imagesUrl.length){

          const finalData = [
            {
              _id: selectedProduct.id,
              images: stepFour.imagesUrl,
            },
          ];
          dispatch(updateProduct(finalData));
          dispatch(resetImagesAfterUpload_EditMod());
    
          alert("image uploaded success!");
          console.log("very first time image uploading")
          reset();

        }
      }else{
        //there are already images uploaded

        if (stepFour.images.length === (stepFour.imagesUrl.length - selectedProduct.images.length)){

          const finalData = [
            {
              _id: selectedProduct.id,
              images: stepFour.imagesUrl,
            },
          ];
          dispatch(updateProduct(finalData));
          dispatch(resetImagesAfterUpload_EditMod());
    
          alert("image uploaded success!");
          console.log("there are already images uploaded")
          reset();
          
        }

      }
      

     
    }
  }, [dispatch, stepFour.imagesUrl, selectedProduct]);

  const deleteAll = () => {
    if (!selectedProduct.id) return alert("There is no items selected");
    if (window.confirm("Are you sure you want to save this image or video ?")) {
      const finalData = [
        {
          _id: selectedProduct.id,
          images: [],
        },
      ];
      dispatch(updateProduct(finalData));
      alert("image deleted success!");
      reset()
    }
  };
  return (
    <div className="flex flex-col w-full">
      <div className="flex items-center">
        <div className="p-4">
          <TextField
            label="Enter item id"
            placeholder="Enter item id"
            value={searchValue}
            type="number"
            onChange={(e) => {
              setSearchValue(e.target.value);
              setImageList([]);
            }}
          />
        </div>
        <div
          onClick={() => {
            searchItem();
          }}
          style={{ background: "var(--main-color)" }}
          className="m-2 p-4 font-extrabold text-white uppercase cursor-pointer"
        >
          Search Item
        </div>
        SELECTED ITEM ID : <div className="bg-green-600 p-3 text-white m-3 font-extrabold rounded-full">{JSON.stringify(selectedProduct.productId)}</div>
      </div>
      <hr></hr>
      {successMessage !== "" || errorMessage !== "" ? (
        <LoadingScreen
          close={true}
          hideContinue={true}
          loading={loading}
          onClose={() => {
            dispatch(resetEdit());
          }}
          errorMessage={errorMessage}
          successMessage={successMessage}
        />
      ) : (
        // <div className="p-5 flex flex-col w-full">
        //   <div className="flex-col w-full p-5 border-2 border-spacing-3 border-gray-500">
        //     <div className=" flex w-full justify-between ">
        //       <div className="flex p-3  w-full justify-center border-4 border-gray-500">
        //         imagesss
        //       </div>
        //       <div className="flex  p-3 w-full justify-center border-4 border-gray-500">
        //         videossv
        //       </div>
        //     </div>
        //     <div className="flex w-full ">
        //     <Box className="image-gallery col-12">
        //       {imgPreview.length === 0 && (
        //         <div className="icon bx bx-photo-album">
        //           <p>Photo Upload</p>
        //         </div>
        //       )}
        //       {imgPreview.map((imgSrc, i) => {
        //         return (
        //           <ImageListItem key={i} sx={{ margin: 2 }}>
        //             <img
        //               className="image-gallery-img"
        //               src={`${imgSrc}`}
        //               alt={"title"}
        //               loading="lazy"
        //             />
        //             <ImageListItemBar
        //               actionIcon={
        //                 <IconButton
        //                   onClick={() => removeImageItem(imgList, i)}
        //                   sx={{ color: "red" }}
        //                   aria-label={`info about ${"title"}`}
        //                 >
        //                   <InfoIcon />
        //                 </IconButton>
        //               }
        //             />
        //           </ImageListItem>
        //         );
        //       })}
        //     </Box>

        //     </div>
        //   </div>
        //   <div className="mt-3 flex justify-end">
        //     <div className="red-button p-4 font-extrabold text-white uppercase cursor-pointer">
        //       Clear
        //     </div>
        //     <div
        //       onClick={() => {
        //         updatePrice();
        //       }}
        //       className="green-button p-4 font-extrabold text-white uppercase cursor-pointer"
        //     >
        //       Update
        //     </div>
        //   </div>
        // </div>

        <Box component="form" noValidate autoComplete="off">
          <div className="row">
            <div className="col-6">
              <div className="image__upload-container ">
                <label htmlFor="imageUpload">
                  <Input
                    onChange={addImage}
                    multiple
                    accept="image/*"
                    id="imageUpload"
                    type="file"
                  />
                  <IconButton
                    style={{ width: "100%" }}
                    size="large"
                    color="warning"
                    aria-label="upload picture"
                    component="span"
                  >
                    <PhotoCamera style={{ fontSize: "3rem" }} />
                  </IconButton>
                </label>

                <Box className="image-gallery col-12">
                  { imgPreview.length ===0 &&  tempImgPreview.length === 0 && (
                    <div className="icon bx bx-photo-album">
                      <p>Photo Upload</p>
                    </div>
                  )}
                  {imgPreview.map((imgSrc, i) => {
                    return (
                      <ImageListItem key={i} sx={{ margin: 2 }}>
                        <img
                          className="image-gallery-img"
                          src={`${imgSrc}`}
                          alt={"title"}
                          loading="lazy"
                        />
                        <ImageListItemBar
                          actionIcon={
                            <IconButton
                              onClick={() => removeImageItem(imgList, i)}
                              sx={{ color: "red" }}
                              aria-label={`info about ${"title"}`}
                            >
                              <InfoIcon />
                            </IconButton>
                          }
                        />
                      </ImageListItem>
                    );
                  })}
                  {tempImgPreview.map((imgSrc, i) => {
                    return (
                      <Tooltip title="Need to Upload">
                      <ImageListItem key={i} sx={{ margin: 2 }}>
                        <img
                        width={'200px'}
                          className="image-gallery-img"
                          src={`${imgSrc}`}
                          alt={"title"}
                          loading="lazy"
                        />
                        <ImageListItemBar
                          actionIcon={
                            <IconButton
                              onClick={() =>
                                removeNotSavedImageItem(tempImageList, i)
                              }
                              sx={{ color: "red" }}
                              aria-label={`info about ${"title"}`}
                            >
                              <InfoIcon />
                              <div className="text-green-400 bx bxs-cloud-upload"></div>
                            </IconButton>
                          }
                        />
                      </ImageListItem>
                      </Tooltip>
                    );
                  })}
                </Box>
              </div>
            </div>
            <div className="col-6">
              <div className="image__upload-container ">
                <label htmlFor="videoUpload">
                  <Input onChange={addVideo} id="videoUpload" type="file" />
                  <IconButton
                    size="large"
                    color="warning"
                    aria-label="upload Video"
                    component="span"
                  >
                    <VideoCall style={{ fontSize: "3rem" }} />
                  </IconButton>
                </label>
                <Box className="image-gallery col-12">
                  {videoPreview.length === 0 && (
                    <div className="icon bx bx-video-recording">
                      <p>Video Upload</p>
                    </div>
                  )}
                  {videoPreview.map((videoSrc, i) => {
                    return (
                      <ImageListItem key={i} sx={{ margin: 2 }}>
                        <video
                          style={{ width: "100%" }}
                          controls
                          autoPlay
                          loop
                          muted
                        >
                          <source src={videoSrc} type="video/mp4"></source>
                        </video>
                        <ImageListItemBar
                          actionIcon={
                            <IconButton
                              sx={{ color: "red" }}
                              aria-label={`info about ${"title"}`}
                              onClick={() =>
                                removeItem(videoPreview, i, setVideoPreview)
                              }
                            >
                              <InfoIcon />
                            </IconButton>
                          }
                        />
                      </ImageListItem>
                    );
                  })}
                </Box>

                <div className="flex w-full justify-end my-8">
                  {tempImageList.length !== 0 && (
                    <div
                      onClick={() => uploadImageAndUpdate()}
                      className="m-3 flex p-3 rounded bg-green-600 text-white hover:bg-green-800 cursor-pointer"
                    >
                      Upload Images {
                      btnDisable && ( <img style={{width:50}} src={spinner} alt="spinner"></img>)
                    }
                    </div>
                  )}
                  <div
                    onClick={() => deleteAll()}
                    className="m-3 flex p-3 rounded bg-red-600 text-white hover:bg-red-800 cursor-pointer"
                  >
                    delete all images
                  </div>
                  <div
                    onClick={() => reset()}
                    className="m-3 flex p-3 rounded bg-blue-600 text-white hover:bg-blue-800 cursor-pointer"
                  >
                    Clear
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Box>
      )}
    </div>
  );
};

export default ProductImageAndVideoUpdate;
